<template>
  <div v-if="id">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="nouvelleEchange"
              >
                <i class="fas fa-plus"></i>
                Nouvel échange
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionEchange"
                v-show="isSelectEchange"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <EchangeDataTable
                :tiers_id="id"
                ref="datatableEchange"
                @onSelect="onSelectEchangeRows"
                @onRowsDelete="deleteEchangeRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/client/client';
import EchangeDataTable from '../components/DataTable.vue';
import names from '@/constants/routes/echange/echange';

export default {
  data() {
    return {
      isSelectEchange: false,
      id: null,
      routes: names,
    };
  },
  components: {
    EchangeDataTable,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    onSelectEchangeRows(isSelectEchange) {
      this.isSelectEchange = isSelectEchange;
    },
    deleteAllSelectionEchange() {
      this.deleteEchangeRows(this.$refs.datatableEchange.idsRowsSelected);
    },
    deleteEchangeRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.ECHANGE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableEchange.loadItems();
                this.isSelectEchange = false;
              })
              .catch();
          }
        });
      }
    },
    isEditRoute() {
      return /.*edit.*/i.test(this.$route.name);
    },

    nouvelleEchange() {
      this.$router.push({
        name: this.routes.create,
      });
    },

    init() {
      this.id = Number(this.$route.params.id);
    },
    submit() {},
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
